import { createSelector } from 'reselect';
import { entitiesSelector } from '@ackee/petrus';

export const authUserSelector = createSelector(entitiesSelector, entities => entities.user);

export const tokensSelector = createSelector(entitiesSelector, entities => entities.tokens);
